import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { retryQuery } from "./api/client";
import { redeemTicket, takeTicket } from "./api/handoff";
import { I18nProvider } from "./i18n";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The fleet changes under us constantly; a short stale time keeps the
      // dashboard honest without hammering the API.
      staleTime: 3000,
      retry: retryQuery,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

const render = () =>
  root.render(
    <React.StrictMode>
      <I18nProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </I18nProvider>
    </React.StrictMode>,
  );

// A tab opened from the admin console arrives holding a ticket instead of a
// session (B2B §7.1). Redeeming it is one round trip, and it happens before
// the first paint on purpose: rendering first would show the login screen to
// whoever has just clicked "Open console", for as long as the network takes.
// `redeemTicket` never rejects — a refusal ends up on that login screen with a
// sentence attached — so this is a delay, never a dead page.
const ticket = takeTicket();
if (ticket) void redeemTicket(ticket).finally(render);
else render();
